import {Time} from '../../model/shared/etc/time';
import {BaseResponse} from '../internal/baseresponse';
export class ADMTimeResult extends BaseResponse {
  data: Time;
}



// WEBPACK FOOTER //
// ./src/app/response/admin/admtimeresult.ts